import takeRequest from '~/store/takeRequest';
import { all } from 'redux-saga/effects';
import * as CompanyActions from './actions';

import { searchCompanyContracts } from './actions';

export function* companySaga() {
  yield all([takeRequest(searchCompanyContracts, { type: 'latest' })]);
  yield takeRequest(CompanyActions.getCompanyMetrics);
  yield takeRequest(CompanyActions.getCompanyContracts);
  yield takeRequest(CompanyActions.getCompanyContact);
  yield takeRequest(CompanyActions.getCompanyById, { type: 'latest' });
  yield takeRequest(CompanyActions.deleteCompanyContact);
  yield takeRequest(CompanyActions.updateCompanyContact);
  yield takeRequest(CompanyActions.createContactCompany);
  yield takeRequest(CompanyActions.getCompanyOverduePayments);
}
